import React from 'react'
import { Header, Footer, BlogDetailSection } from '../components';

const BlogDetails = () => {
    return (
        <>
            <Header />
            <BlogDetailSection />
            <Footer />
        </>
    )
}

export default BlogDetails